import {useSelector} from 'react-redux';

import fwuPackageService from '../../services/fwu/fwuPackageService';
import {selectIotDeviceData} from '../../state/selectors/iotDevice';

const useFwuTargets = (props) => {
    const {isHolder, checkIfHolderConnected} = props || {};
    const iotDevice = useSelector(selectIotDeviceData);

    return fwuPackageService.getFwuTargets({isHolder, checkIfHolderConnected, iotDevice});
};

export default useFwuTargets;
